import {
  QueryFunctionContext,
  UseInfiniteQueryOptions
} from '@tanstack/react-query';

import { AdminV2GroupsApi, AxiosMethods } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';

import { GetAdminGroupsV2Query, getAdminGroupsV2QueryParams } from './Types';

export enum AdminGroupQueryKey {
  ADMIN_GROUPS = 'admin_groups',
  COPY_GROUPS_FROM_USERS = 'copy_groups_from_users'
}

export const getAdminV2GroupsQuery = (
  params: getAdminGroupsV2QueryParams
): UseInfiniteQueryOptions<GetAdminGroupsV2Query> => ({
  queryKey: [AdminGroupQueryKey.ADMIN_GROUPS, params],
  queryFn: (data: QueryFunctionContext) =>
    axiosHelper({
      endpoint: `${AdminV2GroupsApi.Groups}`,
      method: AxiosMethods.GET,
      params: {
        ...params,
        pageNumber: data.pageParam || params.pageNumber
      },
      baseURL: process.env.ADMIN_API_BASE_URL
    }),
  getNextPageParam: (
    lastPage: GetAdminGroupsV2Query,
    allPages: GetAdminGroupsV2Query[]
  ) => {
    const total = allPages?.reduce(
      (acc, cur) => acc + cur?.Data?.Items?.length,
      0
    );
    const currentPageNumber = total / params.pageSize;
    return lastPage?.Data?.Items?.length < params.pageSize
      ? undefined
      : currentPageNumber + 1;
  },
  refetchOnWindowFocus: false,
  cacheTime: 0
});

export const getAdminGroupsFromUsersQuery = ({
  userId
}: {
  userId: number[];
}) => ({
  queryKey: [AdminGroupQueryKey.COPY_GROUPS_FROM_USERS, userId],
  queryFn: () =>
    axiosHelper({
      endpoint: AdminV2GroupsApi.CopyGroupsFromUsers,
      method: AxiosMethods.GET,
      baseURL: process.env.ADMIN_API_BASE_URL,
      params: { userId }
    }),
  select: (data: any) => data?.Data,
  refetchOnWindowFocus: false
});
